import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from "axios";
import configData from "../config/config.json";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifycatch } from "../utils/toast";

const OnboardingStepContext = createContext();

export const OnboardingStepProvider = ({ children }) => {
    const [currentStep, setCurrentStep] = useState(null);
    const [internalStep, setInternalStep] = useState(2);
    const [pubStatus, setPubStatus] = useState(null);
    const [approveUser, setApproveUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [registerStep, setRegisterStep] = useState(0);
    const [registerInternalStep, setRegisterInternalStep] = useState(2);
    const [msgInventory, setMsgInventory] = useState(1);

    const fetchCurrentStep = async () => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let decoded = jwtDecode(token);
            let role = decoded?.role;
            let id = decoded?._id;
            // if (role !== "admin" && role !== "u_admin") {
            //     setLoading(false);
            //     return;
            // }
            try {
                const statusResponse = await axios.get(`${configData.SERVER_URL}user/status?_id=${id}`);
                const data = statusResponse.data.data;

                setCurrentStep(data.step);
                if (data.internal_step !== undefined) {
                    setInternalStep(data.internal_step);
                }

                setPubStatus(data.status);
                setApproveUser(data.approveUser);
                setMsgInventory(data.user_inventory ?? 1);

                setLoading(false);
            } catch (error) {
                if (error?.response) {
                    notifyfailure(error.response.data.message);
                } else {
                    notifycatch();
                }
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCurrentStep();
    }, []);

    useEffect(() => {
        if (msgInventory === 0) {
            document.body.classList.add('user_inventory_off');
        } else {
            document.body.classList.remove('user_inventory_off');
        }
    }, [msgInventory]);

    const handleNext = () => {
        setCurrentStep((prev) => prev + 1);
    };

    return (
        <OnboardingStepContext.Provider value={{ currentStep, setCurrentStep, internalStep, setInternalStep, pubStatus, setPubStatus, approveUser, setApproveUser, loading, handleNext, fetchCurrentStep, registerStep, setRegisterStep, registerInternalStep, setRegisterInternalStep, msgInventory, setMsgInventory }}>
            {children}
        </OnboardingStepContext.Provider>
    );
};

export const useOnboardingStep = () => useContext(OnboardingStepContext);

export default OnboardingStepContext;
